/**
 * @module api-web:financialAffairs/generalLedger/data/accountingSystem
 */
import service from '@/service'

/**
 * 查询 财务-总账-资料-核算体系
 * @param {object} params
 */
export function getList(params) {
  return service['api-web']({
    url: '/fin/gl/data/finAccountSystem/getList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
